export enum PasswordValidationError {
  MIN_LENGTH = 'minlength',
  MIN_LOWER_CASE = 'min-lower-case',
  MIN_UPPER_CASE = 'min-upper-case',
  MIN_NUMBERS = 'min-numbers',
  MIN_SPECIAL_CHARACTERS = 'min-special-characters'
}
